import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { getValidAccessToken } from "../utils/auth";
import { projectId } from "../utils/supabase/info";

export default function PaymentSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const processPayment = async () => {
      // Extract subscriptionId from URL query params first, fallback to sessionStorage
      const urlParams = new URLSearchParams(window.location.search);
      const subscriptionId =
        urlParams.get("subscription_id") ||
        sessionStorage.getItem("paypal_subscription_id");
      const websiteId = sessionStorage.getItem("paypal_website_id");
      const planName = sessionStorage.getItem("paypal_plan_name");
      const billingCycle = sessionStorage.getItem("paypal_billing_cycle");
      const isRevise = sessionStorage.getItem("isRevise") === "true";

      if (!websiteId || !planName || !billingCycle) {
        toast.error("Missing payment details.");
        navigate("/manage-plan");
        return;
      }

      try {
        const accessToken = await getValidAccessToken();
        if (!accessToken) {
          toast.error("Please login to continue");
          navigate("/login");
          return;
        }


        const response = await fetch(
          `https://${projectId}.supabase.co/functions/v1/make-server-3b83895f/payment-process`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              subscriptionId,
              websiteId,
              planName,
              billingCycle,
              isRevise,
            }),
          }
        );

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(errorText || "Failed to process payment");
        }

        const { message } = await response.json();
        toast.success(message);

        // Clear session storage
        sessionStorage.removeItem("paypal_subscription_id");
        sessionStorage.removeItem("paypal_website_id");
        sessionStorage.removeItem("paypal_plan_name");
        sessionStorage.removeItem("paypal_billing_cycle");
        sessionStorage.removeItem("isRevise");
        navigate("/dashboard");
      } catch (error: any) {
        toast.error(error.message || "Failed to process payment.");
        navigate("/manage-plan");
      }
    };

    processPayment();
  }, [navigate]);

  return <div>Processing payment...</div>;
}
